import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { VehicleInspectionsRoutingModule } from './vehicle-inspections-routing.module';
import { InspectionTypesComponent } from './pages/inspection-types/inspection-types.component';
import { InspectionTypeEditComponent } from './pages/inspection-type-edit/inspection-type-edit.component';
import { InspectionsComponent } from './pages/inspections/inspections.component';
import { InspectionsBulkComponent } from './pages/inspections-bulk/inspections-bulk.component';
import { InspectionActionModalComponent } from './modals/inspection-action-modal/inspection-action-modal.component';
import { InspectionCalendarComponent } from './pages/inspection-calendar/inspection-calendar.component';
import { VehicleInspectionsTabComponent } from './partials/vehicle-inspections-tab/vehicle-inspections-tab.component';
import { CalendarModule as CalendarModulePlugin } from 'angular-calendar';

/** Vehicle inspection & MOT calendar (docs/superpowers/specs/2026-10-20-inspection-calendar-design.md). */
@NgModule({
  declarations: [
    InspectionTypesComponent,
    InspectionTypeEditComponent,
    InspectionsComponent,
    InspectionsBulkComponent,
    InspectionActionModalComponent,
    InspectionCalendarComponent,
    VehicleInspectionsTabComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CoreModule,
    CalendarModulePlugin,
    VehicleInspectionsRoutingModule,
  ],
  exports: [InspectionActionModalComponent, VehicleInspectionsTabComponent],
})
export class VehicleInspectionsModule { }
